import Vue from 'vue'

import App from './App.vue'
import VueTippy, { TippyComponent } from 'vue-tippy'
import 'tippy.js/index.css'
import "tippy.js/themes/light.css";

Vue.config.productionTip = false

Vue.use(VueTippy)
Vue.component('tippy', TippyComponent)

const apps = document.querySelectorAll('.t3m-ImageMapContainer')
apps.forEach(app => {
  new Vue({
    render: h => h(App),
  }).$mount(app)
})
